import api, { handleError } from '@/services/axiosInstance';
import { Agent, AgentPromptCommandsResponse } from '@/types/agents';

const AGENTS_API_URL = 'https://api.vh3connect.io/api:i4c4T6bH/agents';

const AGENTS_PROMPT_COMMANDS_API_URL = (agentId: Agent['id']) =>
  `https://api.vh3connect.io/api:i4c4T6bH/agents/${agentId}/commands`;

export const agentsApi = {
  getAgents: async (): Promise<Agent[] | undefined> => {
    try {
      const { data } = await api.get<Agent[]>(AGENTS_API_URL);
      return data;
    } catch (error) {
      handleError(error, 'getAgents');
    }
  },

  getAgentPromptCommands: async (
    agentId: Agent['id']
  ): Promise<AgentPromptCommandsResponse['prompt_commands'] | undefined> => {
    try {
      const { data } = await api.get<AgentPromptCommandsResponse>(
        AGENTS_PROMPT_COMMANDS_API_URL(agentId)
      );
      return data.prompt_commands;
    } catch (error) {
      handleError(error, 'getAgentPromptCommands');
    }
  },
};
